import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AlertStatusService {

  constructor(private http: HttpClient) { }

  getAlertStatus(): Observable<any>{
    return this.http.get(`${environment.yomaApiURL}/settings/alert_status`);
  }

  setAlertStatus(alert: any): Observable<any>{
    return this.http.post(`${environment.yomaApiURL}/settings/alert_status`, alert);
  }

  deleteAlertStatus(): Observable<any>{
    return this.http.delete(`${environment.yomaApiURL}/settings/alert_status`);
  }
}
